// src/Ontology/scene.js
import React, { useRef, useEffect, useState } from "react";
import "./scence.css";

// 10 大场景分类（页面顶部会加一个 "All" 选项，用于重置筛选）
export const CATEGORIES = [
  "All",
  "Sponsored",
  "Food & Beverage",
  "Retail & Shopping",
  "Office & Workspaces",
  "Residential & Interiors",
  "Entertainment & Sports",
  "Transport Hubs & Vehicles",
  "Public Services & Emergency",
  "Cultural & Landmarks",
  "Nature & Outdoor Landscapes",
  "Industrial & Technical Interiors",
  "Science"
];

// 背景链接数组——在 url 里填入你的 embed 链接
export const BG_LINKS = [
  // —— Lex Original ——

    {
    "category": "Sponsored",
    "name": "LEX Fantasy",
    "url": "https://sketchfab.com/models/247b6624576b48e59ee44af5a71e0e2f/embed?autostart=1"
  },

  {
    "category": "Sponsored",
    "name": "LEX Advertising",
    "url": "https://sketchfab.com/models/23567690020d4767a99f53ad5d59a161/embed?autostart=1"
  },
    {
    "category": "Sponsored",
    "name": "McDonald's",
    "url": "https://sketchfab.com/models/2842f313c108426f87f68ff2cb07472f/embed?autostart=1"
  },
  {
    "category": "Sponsored",
    "name": "FedEx",
    "url": "https://sketchfab.com/models/554a6a4d30d342f2aca8735aaa69f954/embed?autostart=1"
  },
  {
    "category": "Sponsored",
    "name": "Amazon Prime",
    "url": "https://sketchfab.com/models/0641e66ea33c415694cf84f786178960/embed?autostart=1"
  },
  {
    "category": "Sponsored",
    "name": "New York Subway",
    "url": "https://sketchfab.com/models/5cacafef3f0e4749ba5b59f280539813/embed?autostart=1"
  },
    {"category": "Sponsored",
    "name": "American Airline",
    "url": "https://sketchfab.com/models/1f5aeca4bfea46228184453d749cfef3/embed?autostart=1"

  },
  {
    "category": "Sponsored",
    "name": "ISS",
    "url": "https://sketchfab.com/models/b7d40d89fcbd4c998462380545f391b6/embed?autostart=1"
  },
  {
    "category": "Sponsored",
    "name": "Hintze Hall",
    "url": "https://sketchfab.com/models/45f5e56887f44075bbf283977c99541f/embed?autostart=1"
  },

  {
    "category": "Sponsored",
    "name": "Zillow",
    "url": "https://sketchfab.com/models/9f5e88da20ea4f30a142f5f5a29fbb1c/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Flying Windmill Island (Gorillaz) - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/247b6624576b48e59ee44af5a71e0e2f/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "New Retro Girl - 3D model by turrican85",
    "url": "https://sketchfab.com/models/bd2f7594b8434e3fa775e3fdaaeb2f2e/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Advertising Billboard (Version 1) High-Poly - Buy Royalty Free 3D model by VIS-All-3D (@VIS-All)",
    "url": "https://sketchfab.com/models/23567690020d4767a99f53ad5d59a161/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Low Poly Billboard Sign - Overhang - Download Free 3D model by JeffK (@jeffkolada)",
    "url": "https://sketchfab.com/models/bbbc335c94724061b5caaed3bb52b7cd/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "The Iron Giant - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/53fbb041023045b799cb4147ca4b006e/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Stylized Low Poly Gym Asset - 3D model by tbatuer",
    "url": "https://sketchfab.com/models/8f7259528f774ef49178e254ffac518b/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym (Lat) animated - Buy Royalty Free 3D model by luismi93",
    "url": "https://sketchfab.com/models/164f19da64494642be5b4a203c1b1468/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Floating Island - Forgotten Shrine - 3D model by Yosapat Panutyotin (@Matcha.Tea)",
    "url": "https://sketchfab.com/models/43be02c79a1c4092b774bacda18b2f34/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym - Buy Royalty Free 3D model by Janis Zeps (@Zeps3D)",
    "url": "https://sketchfab.com/models/fbd1baf5f56743e6bd4299ad91473b9a/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym 5 exercises animated - Buy Royalty Free 3D model by luismi93",
    "url": "https://sketchfab.com/models/7b5abc01fd804bc7b53da6259234eaf6/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Bar store coffee shop interior lowpoly🍹🍸 - Buy Royalty Free 3D model by haykel-shaba (@haykel1993)",
    "url": "https://sketchfab.com/models/035706936c1c434e9f9a28e15cf72401/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Hospital Building Cutaway with Characters - 3D model by Alexander Kovalev / Svitlana Prylepska (@viznum)",
    "url": "https://sketchfab.com/models/1f84ad2508674f749290b4d8a9561bfe/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Hospital Room / Hospital Ward - Buy Royalty Free 3D model by Studio Lab (@studiolab.dev)",
    "url": "https://sketchfab.com/models/fd58a2f8e93447c18e52a5cb1c1e77dd/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "The Convenience Store - Download Free 3D model by Merow (@TehMerow)",
    "url": "https://sketchfab.com/models/d81380e64c2c4b85b4cf58910f649312/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Court_Room - Buy Royalty Free 3D model by 3D Dreamscapes (@pradeep1)",
    "url": "https://sketchfab.com/models/b6d2b91c652148479400923a2cabb2d1/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Classroom - Download Free 3D model by Pino_156 (@titi_156)",
    "url": "https://sketchfab.com/models/d4553cc2008242849214e4cbf8ad8551/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "New York Subway Game-Ready - Buy Royalty Free 3D model by Troublesome. (@spospider)",
    "url": "https://sketchfab.com/models/2d12357275cd4205bd1d435e4b3b0feb/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "G0017 VR Virtual Reality Enviroment Office - Buy Royalty Free 3D model by VRA (@architect47)",
    "url": "https://sketchfab.com/models/3c94c7da3b0648f1b67d9e795e9a4780/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Conference Room - Buy Royalty Free 3D model by Janis Zeps (@Zeps3D)",
    "url": "https://sketchfab.com/models/da862325a9dd4e8baa638fb72b9b2325/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Pew Engineering Quad - Download Free 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/da4ed75e7e4745aaaf38f5ff3dbdde80/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Flying Windmill Island (Gorillaz) - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/247b6624576b48e59ee44af5a71e0e2f/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "New Retro Girl - 3D model by turrican85",
    "url": "https://sketchfab.com/models/bd2f7594b8434e3fa775e3fdaaeb2f2e/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Advertising Billboard (Version 1) High-Poly - Buy Royalty Free 3D model by VIS-All-3D (@VIS-All)",
    "url": "https://sketchfab.com/models/23567690020d4767a99f53ad5d59a161/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Low Poly Billboard Sign - Overhang - Download Free 3D model by JeffK (@jeffkolada)",
    "url": "https://sketchfab.com/models/bbbc335c94724061b5caaed3bb52b7cd/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "The Iron Giant - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/53fbb041023045b799cb4147ca4b006e/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Stylized Low Poly Gym Asset - 3D model by tbatuer",
    "url": "https://sketchfab.com/models/8f7259528f774ef49178e254ffac518b/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym (Lat) animated - Buy Royalty Free 3D model by luismi93",
    "url": "https://sketchfab.com/models/164f19da64494642be5b4a203c1b1468/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Floating Island - Forgotten Shrine - 3D model by Yosapat Panutyotin (@Matcha.Tea)",
    "url": "https://sketchfab.com/models/43be02c79a1c4092b774bacda18b2f34/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym - Buy Royalty Free 3D model by Janis Zeps (@Zeps3D)",
    "url": "https://sketchfab.com/models/fbd1baf5f56743e6bd4299ad91473b9a/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gym 5 exercises animated - Buy Royalty Free 3D model by luismi93",
    "url": "https://sketchfab.com/models/7b5abc01fd804bc7b53da6259234eaf6/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Bar store coffee shop interior lowpoly🍹🍸 - Buy Royalty Free 3D model by haykel-shaba (@haykel1993)",
    "url": "https://sketchfab.com/models/035706936c1c434e9f9a28e15cf72401/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Hospital Building Cutaway with Characters - 3D model by Alexander Kovalev / Svitlana Prylepska (@viznum)",
    "url": "https://sketchfab.com/models/1f84ad2508674f749290b4d8a9561bfe/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Hospital Room / Hospital Ward - Buy Royalty Free 3D model by Studio Lab (@studiolab.dev)",
    "url": "https://sketchfab.com/models/fd58a2f8e93447c18e52a5cb1c1e77dd/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "The Convenience Store - Download Free 3D model by Merow (@TehMerow)",
    "url": "https://sketchfab.com/models/d81380e64c2c4b85b4cf58910f649312/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Court_Room - Buy Royalty Free 3D model by 3D Dreamscapes (@pradeep1)",
    "url": "https://sketchfab.com/models/b6d2b91c652148479400923a2cabb2d1/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Classroom - Download Free 3D model by Pino_156 (@titi_156)",
    "url": "https://sketchfab.com/models/d4553cc2008242849214e4cbf8ad8551/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "New York Subway Game-Ready - Buy Royalty Free 3D model by Troublesome. (@spospider)",
    "url": "https://sketchfab.com/models/2d12357275cd4205bd1d435e4b3b0feb/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "G0017 VR Virtual Reality Enviroment Office - Buy Royalty Free 3D model by VRA (@architect47)",
    "url": "https://sketchfab.com/models/3c94c7da3b0648f1b67d9e795e9a4780/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Conference Room - Buy Royalty Free 3D model by Janis Zeps (@Zeps3D)",
    "url": "https://sketchfab.com/models/da862325a9dd4e8baa638fb72b9b2325/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Pew Engineering Quad - Download Free 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/da4ed75e7e4745aaaf38f5ff3dbdde80/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Interdimensional Floating Islands - Download Free 3D model by Iso Game Lab (@isogl)",
    "url": "https://sketchfab.com/models/0742e636aa9a40b5865436511e3595cf/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Olin Hall Classroom - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/4b563f9b485142e591850395c2cadeb0/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Upson Hall Study Room - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/d3b03f0184234849a9618a576023e7d2/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Gates Hall - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/fc52bfbfe3424cd3988238d60c38a65e/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Vans Old Skool Navy Fashion Sneaker - 3D model by Vincent Page (@vincentpage)",
    "url": "https://sketchfab.com/models/7d09cb5b7dea4c4d84fac9b735eb4525/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "OUTSIDE | POSSESSIONS GAME | APPLE ARCADE - 3D model by murilo.kleine",
    "url": "https://sketchfab.com/models/7241f0ba547d49ee97393cb4583f3916/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Johann-Strauß-Denkmal - Download Free 3D model by noe-3d.at (@www.noe-3d.at)",
    "url": "https://sketchfab.com/models/d7b1cf114af248e4a9258eaa7325951f/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Lex Original",
    "name": "SMART BAG BLK - Buy Royalty Free 3D model by Bartholomew Koziel (@bkoziel)",
    "url": "https://sketchfab.com/models/2bfeebf1c60d40d7946c8e7f833a1289/embed?autospin=1&autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "Ramen - 3D model by Skyfox13 (@podderkuntal25)",
    "url": "https://sketchfab.com/models/7b53981c3461453da9fe11e5a7fd8aa8/embed?autostart=1"
  },
  {
    "category": "Lex Original",
    "name": "App Island - Download Free 3D model by nickheitzman",
    "url": "https://sketchfab.com/models/2d22e05e4049493c9f47de897bb67c5e/embed?autostart=1"
  },

  {
    "category": "Science",
    "name": "Quantum Computer",
    "url": "https://sketchfab.com/models/82006aac41744663a161ab844264ac2a/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Animated Full Human Body Anatomy",
    "url": "https://sketchfab.com/models/9b0b079953b840bc9a13f524b60041e4/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Charité University Hospital - Operating Room",
    "url": "https://sketchfab.com/models/9ec46c4d615a4581a235eebfb162f574/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Bacterial cell structure",
    "url": "https://sketchfab.com/models/42439edc90cd4d87b8ae322a4dcee8de/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Arterial vessel tour",
    "url": "https://sketchfab.com/models/246576050a644cb4ae16840922385e39/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Animal Cell",
    "url": "https://sketchfab.com/models/0b15c013059844d7a26c1f16752f8b61/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Eukaryotic Cell",
    "url": "https://sketchfab.com/models/b7d84e5f2d5e411fbb195ab2742f2256/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "Biology animal Cell",
    "url": "https://sketchfab.com/models/4d60cacd5fa543058cfe65064e2d4d53/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Nucleus - Cell Organelles",
    "url": "https://sketchfab.com/models/7e01bff42b2d47fab640503bcef071e6/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Neurons",
    "url": "https://sketchfab.com/models/20e930a5fae5457fa6d1738afa00c7bb/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "ISS Interior—International Space Station",
    "url": "https://sketchfab.com/models/4ab5602b8749485797ea57ef7d4cb5c1/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "US Core Inflation 1997-2019",
    "url": "https://sketchfab.com/models/a224cec6cb8a4c03a5ce82c1ede1be4f/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "An electromagnetic wave",
    "url": "https://sketchfab.com/models/a7e7f0e0b22d4828bbadf3717541d7d2/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Circular polarisation of an electromagnetic wave",
    "url": "https://sketchfab.com/models/0bf07181c0314a7c891cb6944a37ea97/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "US Earnings Growth Model (S&P 500)",
    "url": "https://sketchfab.com/models/fdc4987c2db14627b1b8d96693a9deed/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Motherboard and its parts",
    "url": "https://sketchfab.com/models/bfcaf54d2a604e9b9319611adab8a589/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Turbojet engine Demonstration",
    "url": "https://sketchfab.com/models/dc1621a57fc744fba9f5506225dbfe90/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Ejecta distribution in the SNR IC 443",
    "url": "https://sketchfab.com/models/d08f9fbadcb845ca8a7886f21e6706e8/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "PWR Nuclear Reactor",
    "url": "https://sketchfab.com/models/e93a8031d7e1486eae36f2074969f3cb/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Iron distribution in a Supernova Remnant",
    "url": "https://sketchfab.com/models/e2f1a3e653084b4189a3049335aeb513/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "The chemical content of protoplanetary disks",
    "url": "https://sketchfab.com/models/6c7ba1ba112c408da35736f881788130/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "Structure of an Active Galactic Nucleus (AGN)",
    "url": "https://sketchfab.com/models/c48972411beb4273a6226c6ca2eb9163/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Science",
    "name": "Stars 3-2-16.c4d",
    "url": "https://sketchfab.com/models/f8c15b12ed5c4b3487ecab189756baec/embed?autostart=1"
  },
  {
    "category": "Science",
    "name": "Apollo 11 Moon Landing (VR Experience)",
    "url": "https://sketchfab.com/models/2324f9685404433fa6231c7cb2cd2ff5/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Food & Beverage",
    "name": "Europe cute cafe - day - Buy Royalty Free 3D model by VRA (@architect47)",
    "url": "https://sketchfab.com/models/ba055f7fee194872905f2ee41e3317f9/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Low Poly Chinese Restaurant Interior - Buy Royalty Free 3D model by AirStudios (@airstudios3d)",
    "url": "https://sketchfab.com/models/4d90de964d9d4c4d96a3f97f90e0be64/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "My First Resturant - 3D model by Joshua Nigel Patrick (@joshuanigelpatrick)",
    "url": "https://sketchfab.com/models/25f0650aa81449cbac2503ec862d80ae/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Coffee Shop Set - 3D model by CyberFox 3D Studio (@cyberfox3d)",
    "url": "https://sketchfab.com/models/8e02c591d1584e1eb8b38c7b401f05d8/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Small Coffee Shop - Download Free 3D model by Pukka Films (@pukkafilms)",
    "url": "https://sketchfab.com/models/2d2f997095d646d5ad4c6595b286b70c/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "McDonald's MENU - Download Free 3D model by ISAACLAB (@stevelamuerte)",
    "url": "https://sketchfab.com/models/2842f313c108426f87f68ff2cb07472f/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Icecream truck - Buy Royalty Free 3D model by Veaceslav Condraciuc (@FLED)",
    "url": "https://sketchfab.com/models/6ea701d26546447d80d6fd93e2966348/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Marrakesh Tea Party - 3D model by natapon",
    "url": "https://sketchfab.com/models/a4f97d071dca4bd4865022df72e3976a/embed?autostart=1"
  },
  {
    "category": "Food & Beverage",
    "name": "Sketchfab Weekly - Birthday - Diner party - 3D model by Dark Mermaids (@darkmermaids)",
    "url": "https://sketchfab.com/models/a1391a26693c46ecbb984bd24abc6ab6/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Supermarket - Buy Royalty Free 3D model by heng1210",
    "url": "https://sketchfab.com/models/97e2e39312654deb869d227842746b08/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Supermarket - Buy Royalty Free 3D model by heng1210",
    "url": "https://sketchfab.com/models/97e2e39312654deb869d227842746b08/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Realistic Post Apocalyptic Mall - Buy Royalty Free 3D model by Aligned Games (@Johannesnienaber)",
    "url": "https://sketchfab.com/models/6b202dc316bf4e7c9c070fda5073d57d/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Court_Room - Buy Royalty Free 3D model by 3D Dreamscapes (@pradeep1)",
    "url": "https://sketchfab.com/models/b6d2b91c652148479400923a2cabb2d1/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Advertising Billboard (Version 1) High-Poly - Buy Royalty Free 3D model by VIS-All-3D (@VIS-All)",
    "url": "https://sketchfab.com/models/23567690020d4767a99f53ad5d59a161/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Interdimensional Art Gallery - floating platform - Download Free 3D model by Elin (@ElinHohler)",
    "url": "https://sketchfab.com/models/c2660ab00f4e4fc09de7503000d62430/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "[Korwa] - dances to (Classic) on sketchfab「 MMD」 - 3D model by codealdnoah (@deuschanz)",
    "url": "https://sketchfab.com/models/b251d7cdce3a4701b3fde7eea0f7d899/embed?autostart=1"
  },
  {
    "category": "Retail & Shopping",
    "name": "Wifi Rental - Download Free 3D model by lizhiqiang (@lizhiqiang89)",
    "url": "https://sketchfab.com/models/49243bb925e34557988f2008aceb1ccc/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "OFFICE WORK DESK LOWPOLY BUREAU GAME ASSETS - Buy Royalty Free 3D model by haykel-shaba (@haykel1993)",
    "url": "https://sketchfab.com/models/cf723624ef1c400b98f540532391c61a/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "Modern Office Interior - Buy Royalty Free 3D model by MD Ashfaq Bin Arif (@tafar165)",
    "url": "https://sketchfab.com/models/a95a81f32bb1461da296d1e2351e7093/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "Small Office - Download Free 3D model by dylanheyes",
    "url": "https://sketchfab.com/models/393a8fec31bf41a99a49a57bbcf02ac8/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "Minimalistic Modern Office - Download Free 3D model by dylanheyes",
    "url": "https://sketchfab.com/models/5540183da1c7452f810f8de33734879a/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "Simple Modern Living Room - Download Free 3D model by dylanheyes",
    "url": "https://sketchfab.com/models/e88651f56d78486c8e83dddf1af057c3/embed?autostart=1"
  },
  {
    "category": "Office & Workspaces",
    "name": "Floating Island - Forgotten Shrine - 3D model by Yosapat Panutyotin (@Matcha.Tea)",
    "url": "https://sketchfab.com/models/43be02c79a1c4092b774bacda18b2f34/embed?autostart=1"
  },
  {
    "category": "Residential & Interiors",
    "name": "Bed Room 01 - Baked - Buy Royalty Free 3D model by 5th Dimension (@5th-Dimension)",
    "url": "https://sketchfab.com/models/08d36d567bdc4532965f881a3c3d8795/embed?autostart=1"
  },
  {
    "category": "Residential & Interiors",
    "name": "Bathroom Interior - 3D model by Akshaykhedkar97",
    "url": "https://sketchfab.com/models/7609ef43ffc04cc280f1525ffdc6d89a/embed?autostart=1"
  },
  {
    "category": "Residential & Interiors",
    "name": "Simple Modern Living Room - Download Free 3D model by dylanheyes",
    "url": "https://sketchfab.com/models/e88651f56d78486c8e83dddf1af057c3/embed?autostart=1"
  },
  {
    "category": "Residential & Interiors",
    "name": "Sci-fi Portal & Gallery for Product Showcase - Buy Royalty Free 3D model by BehNaM (@GbehnamG)",
    "url": "https://sketchfab.com/models/912f2d1ac62443f0ab05e00f15e7b45b/embed?autostart=1"
  },
  {
    "category": "Residential & Interiors",
    "name": "Porcelain cup set - Buy Royalty Free 3D model by Izat Abdraimov (@izatabdraimov)",
    "url": "https://sketchfab.com/models/a9cad79d660f45da8b63761d03a46530/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Music Theatre - Buy Royalty Free 3D model by heng1210",
    "url": "https://sketchfab.com/models/9c2f4ea63b7f4b3f86baf0f12b85047a/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Medium-sized modern stadium (full interior) - Buy Royalty Free 3D model by anDDDres",
    "url": "https://sketchfab.com/models/110efe1777714be8afa29a5a5279df73/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Basketball Arena - Buy Royalty Free 3D model by heng1210",
    "url": "https://sketchfab.com/models/68a1784b3ec5421f8d11f6bef24edb0e/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Boxing Arena - Buy Royalty Free 3D model by heng1210",
    "url": "https://sketchfab.com/models/6aca5fdf8b574deeacb97b31fa4c62dd/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Amusement park - 3D model by Sergei Bashirov (@failyren)",
    "url": "https://sketchfab.com/models/6077d5e0536a43a1b7b0427d0e957959/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Amusement park - Download Free 3D model by Megame Studio (@megame1)",
    "url": "https://sketchfab.com/models/33d83e7028824fc68e544e05fcdba541/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "Amusement Park - 3D model by yuki (@yuki004002)",
    "url": "https://sketchfab.com/models/939cd38c82594414b9bf5ea713b53ec8/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "VR Meta Meeting Island & Disco Party | Baked - Buy Royalty Free 3D model by Spazio Silvestre (@spazio_silvestre)",
    "url": "https://sketchfab.com/models/a7b5795d254e4ab1b0318ae0a3974916/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "DJ Room - Download Free 3D model by shrikanthpv8",
    "url": "https://sketchfab.com/models/c144937b00644ba4ab0f0c05ef7dd375/embed?autostart=1"
  },
  {
    "category": "Entertainment & Sports",
    "name": "VR Room - VR Art Gallery - Buy Royalty Free 3D model by carlcapu9",
    "url": "https://sketchfab.com/models/d292d9ca03e849b9a9f1a41ab1406154/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "School Bus - Low Poly - Buy Royalty Free 3D model by MSWoodvine",
    "url": "https://sketchfab.com/models/f18faa73da8c4ee3a19e8db1d4ae4cd9/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "American Muscle Car Widebody - Buy Royalty Free 3D model by Naudaff3D",
    "url": "https://sketchfab.com/models/29c89230eec24f12a4eff80ef2a600a6/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "FedEx van - Download Free 3D model by memoov (@movartD)",
    "url": "https://sketchfab.com/models/554a6a4d30d342f2aca8735aaa69f954/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Amazon Prime shipping box - Download Free 3D model by NikR",
    "url": "https://sketchfab.com/models/0641e66ea33c415694cf84f786178960/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Icecream truck - Buy Royalty Free 3D model by Veaceslav Condraciuc (@FLED)",
    "url": "https://sketchfab.com/models/6ea701d26546447d80d6fd93e2966348/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Subway Station Assets - Buy Royalty Free 3D model by AirStudios (@airstudios3d)",
    "url": "https://sketchfab.com/models/5cacafef3f0e4749ba5b59f280539813/embed?autostart=1"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "3D Train Station 09 - Buy Royalty Free 3D model by Giimann",
    "url": "https://sketchfab.com/models/1ef130e1fcf040ee9cd7ee32a9e44989/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Airport Final Big Scene - Download Free 3D model by assetfactory",
    "url": "https://sketchfab.com/models/88c17adc828a4952a2d06737fb62cfa4/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Airport Check-in Building 01 - Buy Royalty Free 3D model by Giimann",
    "url": "https://sketchfab.com/models/82ae6c35eec446b49100da2039f3af57/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Transport Hubs & Vehicles",
    "name": "Low Poly Airport With Airplanes, Ground Vehicles - Buy Royalty Free 3D model by AirStudios (@airstudios3d)",
    "url": "https://sketchfab.com/models/1f5aeca4bfea46228184453d749cfef3/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "police station (inside) - Buy Royalty Free 3D model by Mostafa Ebrahim (@mostafaebrahiem1998)",
    "url": "https://sketchfab.com/models/7453637275f444618cf51cb78f321040/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "Police Station - Buy Royalty Free 3D model by danielmikulik",
    "url": "https://sketchfab.com/models/0c0a5a16ce9c4921b7fa26f1fa0c92e0/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "Emergency Call Box / Autobahn Notrufsäule - Buy Royalty Free 3D model by VIS-All-3D (@VIS-All)",
    "url": "https://sketchfab.com/models/17e34a72d8964e53b2129c2a94da0b60/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "Medical First Aid Emergency Kit - Download Free 3D model by RayznGames (@Rayzn)",
    "url": "https://sketchfab.com/models/d588fee3c3a94c0d82884c2fc1505e9c/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "Gas station - 3D model by AnnaBelle Fibonacci (@annabellefibonacci)",
    "url": "https://sketchfab.com/models/e1d6fdc783394bc088bd4cd885368165/embed?autostart=1"
  },
  {
    "category": "Public Services & Emergency",
    "name": "Cyberpunk station - Download Free 3D model by Daniel.Orlando.Tapia",
    "url": "https://sketchfab.com/models/36a716f3ce0c47f2a37a424789414b90/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "The Iron Giant - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/53fbb041023045b799cb4147ca4b006e/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Philadelphia Museum of Art Pediment - 3D model by Taylor (@thoulihan)",
    "url": "https://sketchfab.com/models/ad89e06165fa48f99e895e683efe1db8/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Hintze Hall - Download Free 3D model by artfletch",
    "url": "https://sketchfab.com/models/45f5e56887f44075bbf283977c99541f/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Chiesa Nuova - 3D model by Matthew Brennan (@matthewbrennan)",
    "url": "https://sketchfab.com/models/a38653b41f1143958df3d9819077ea84/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Church Of St Peter Stourton - Download Free 3D model by artfletch",
    "url": "https://sketchfab.com/models/5c65299f7762407686905ca330099245/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Disused church - Buy Royalty Free 3D model by xinige",
    "url": "https://sketchfab.com/models/16a2babac80a4d839e63e07c417dbc91/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Èze Village - France - Download Free 3D model by Azad Balabanian (@azadbal)",
    "url": "https://sketchfab.com/models/a18a1449661643e6ab98640a3e7eafc1/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Lomnický Peak | 2634m | High Tatras Slovakia - 3D model by Overhead4D (@OVERHEAD)",
    "url": "https://sketchfab.com/models/f9d96fca765044f6a0e83f24bd9dcaa0/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Miami Cityscape Florida, USA - Buy Royalty Free 3D model by LibanCiel",
    "url": "https://sketchfab.com/models/c74e699d219c4065aaab00d61b04c5cd/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Manhattan, New York City USA - Buy Royalty Free 3D model by LibanCiel",
    "url": "https://sketchfab.com/models/34fb91b625994c9bb0be853ddaf0fb5f/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "2424 Ocean Avenue, Brooklyn - Wilk Real Estate - 3D model by GeoCV",
    "url": "https://sketchfab.com/models/9f5e88da20ea4f30a142f5f5a29fbb1c/embed?autostart=1"
  },
  {
    "category": "Cultural & Landmarks",
    "name": "Petrovsky travel palace in Moscow - 3D model by Medv3D",
    "url": "https://sketchfab.com/models/8b877b1776794c139d80fd93999003f0/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Flying Windmill Island (Gorillaz) - 3D model by Carlos.Colado",
    "url": "https://sketchfab.com/models/247b6624576b48e59ee44af5a71e0e2f/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Open your Mind ( AI Stoned Ape Theory version ) - Download Free 3D model by Miguelangelo Rosario (@miguelangelo2k)",
    "url": "https://sketchfab.com/models/147ba6ce9a8447438960cc83b1e4b79e/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Happy bicycle day 2018 ! 75 Years LSD - Download Free 3D model by Miguelangelo Rosario (@miguelangelo2k)",
    "url": "https://sketchfab.com/models/5e7126cb68d0432e9799910bc2f7bb05/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Hospital Building Cutaway with Characters - 3D model by Alexander Kovalev / Svitlana Prylepska (@viznum)",
    "url": "https://sketchfab.com/models/1f84ad2508674f749290b4d8a9561bfe/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Floating Iceberg Island",
    "url": ""
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Cloud Station - Download Free 3D model by Alexa Kruckenberg (@AlexaKruckenberg)",
    "url": "https://sketchfab.com/models/26f81b24d83441ba88c7e80a52adbaaf/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Animated Ocean Scene Tutorial Example 1 - Download Free 3D model by 3DHaupt (@dennish2010)",
    "url": "https://sketchfab.com/models/f2f8e84f6eb443ff95cf6a40f624fdec/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Gates Hall - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/fc52bfbfe3424cd3988238d60c38a65e/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Classroom - Download Free 3D model by Pino_156 (@titi_156)",
    "url": "https://sketchfab.com/models/d4553cc2008242849214e4cbf8ad8551/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Olin Hall Classroom - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/4b563f9b485142e591850395c2cadeb0/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "OUTSIDE | POSSESSIONS GAME | APPLE ARCADE - 3D model by murilo.kleine",
    "url": "https://sketchfab.com/models/7241f0ba547d49ee97393cb4583f3916/embed?autostart=1"
  },
  {
    "category": "Nature & Outdoor Landscapes",
    "name": "Bar store coffee shop interior lowpoly🍹🍸 - Buy Royalty Free 3D model by haykel-shaba (@haykel1993)",
    "url": "https://sketchfab.com/models/035706936c1c434e9f9a28e15cf72401/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Stylized Low Poly Gym Asset - 3D model by tbatuer",
    "url": "https://sketchfab.com/models/8f7259528f774ef49178e254ffac518b/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Upson Hall Study Room - 3D model by Cornell Engineering (@engradmissions)",
    "url": "https://sketchfab.com/models/d3b03f0184234849a9618a576023e7d2/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Trippy flower animation loosing it... - Download Free 3D model by Miguelangelo Rosario (@miguelangelo2k)",
    "url": "https://sketchfab.com/models/f379cf2c400645b8b22f3989cc5ff6dc/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "SMART BAG BLK - Buy Royalty Free 3D model by Bartholomew Koziel (@bkoziel)",
    "url": "https://sketchfab.com/models/2bfeebf1c60d40d7946c8e7f833a1289/embed?autospin=1&autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Johann-Strauß-Denkmal - Download Free 3D model by noe-3d.at (@www.noe-3d.at)",
    "url": "https://sketchfab.com/models/d7b1cf114af248e4a9258eaa7325951f/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Female Scan - Woman Holding a Snake 51 - Buy Royalty Free 3D model by human-engine",
    "url": "https://sketchfab.com/models/703570e76a9e4b9c89e90e5be7c9126f/embed?autospin=1&autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "International Space Station : ISS - Buy Royalty Free 3D model by Studio Lab (@studiolab.dev)",
    "url": "https://sketchfab.com/models/b7d40d89fcbd4c998462380545f391b6/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Animated Dance Teacher - Flair - 3D model by LasquetiSpice",
    "url": "https://sketchfab.com/models/a2b070bc0bc44fd081a6690220087d27/embed?autospin=1&autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Hospital Room / Hospital Ward - Buy Royalty Free 3D model by Studio Lab (@studiolab.dev)",
    "url": "https://sketchfab.com/models/fd58a2f8e93447c18e52a5cb1c1e77dd/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Rigged model created with iPhone - 3D model by in3D (@in3D_io)",
    "url": "https://sketchfab.com/models/869e1cd9b9514d0591dfecc12d2c078c/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Dance - 3D model by kanistra",
    "url": "https://sketchfab.com/models/fafefdddfc9346f9ba76bb423e0a5089/embed?autospin=1&autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Autumnal Forest - Download Free 3D model by Talariand31",
    "url": "https://sketchfab.com/models/c5d9b82fed36465797b4d278833a3781/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Dance like an Egyptian - Download Free 3D model by Miguelangelo Rosario (@miguelangelo2k)",
    "url": "https://sketchfab.com/models/cb32545d75904bfc9de3bd65f169df8a/embed?autospin=1&autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Modular Matrix - Download Free 3D model by Tycho Magnetic Anomaly (@Tycho_Magnetic_Anomaly)",
    "url": "https://sketchfab.com/models/950fe37138174cf0b216dd60e6e162fd/embed?autostart=1&ui_infos=0"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Virtual Reality Meta Room 2022 + 3ds Max Corona - Buy Royalty Free 3D model by Marcin Lubecki (@Lubus)",
    "url": "https://sketchfab.com/models/65c9eb97d7de47fe9d475d76f02d6b26/embed?autostart=1"
  },
  {
    "category": "Industrial & Technical Interiors",
    "name": "Dancing Woman - 3D model by Moto Waganari (@moto.waganari)",
    "url": "https://sketchfab.com/models/be9cdf844d774e3ca6e638c10dade9bd/embed?autospin=1&autostart=1"
  }
];

export default function ScenePicker({ links = BG_LINKS, current, setCurrent, showPicker, setShowPicker }) {
  const popoverRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState("All");

  useEffect(() => {
    if (!showPicker) return;
    const handleClickOutside = e => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker, setShowPicker]);

  if (!showPicker) return null;

  // 根据当前分类筛选
  const filteredLinks = activeCategory === "All"
    ? links
    : links.filter(item => item.category === activeCategory);

  return (
    <div ref={popoverRef} className="scene-popover">
      {/* 分类标签栏 */}
      <div className="category-tabs">
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`tab-item${cat === activeCategory ? " active" : ""}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* 场景网格 */}
      <div className="scene-grid">
        {filteredLinks.map((item, idx) => {
          // 找到这个 item 在原 links 数组中的索引
          const originalIndex = links.findIndex(l => l === item);
          return (
            <button
              key={originalIndex}
              className={`scene-button${originalIndex === current ? " active" : ""}`}
              onClick={() => {
             if (originalIndex === current) {
    return;
  }
  setCurrent(originalIndex);
  setShowPicker(false);
              }}
            >
              <div className="scene-name">{item.name}</div>
              <div className="scene-category">{item.category}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
